export const WITHDRAWAL_NETWORKS = ['ERC-20', 'BEP-20', 'TRC-20'] as const;

export type WithdrawalNetwork = (typeof WITHDRAWAL_NETWORKS)[number];
